module.exports = __webpack_public_path__ + "static/og-aa1a7972acd6945b7500babeae4f6294.png";